import React, { useState, useEffect } from 'react';
import { LuSend, LuX } from 'react-icons/lu';

const PartnerContact = ({ isOpen, onClose }) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const formData = new FormData(event.target);
            const response = await fetch(
                'https://docs.google.com/forms/d/e/1FAIpQLSf0CgA28qcqS1taXs5qUqMz8OV2C_EtP8iwX439y1f_vlLQvg/formResponse',
                {
                    method: 'POST',
                    body: formData,
                    mode: 'no-cors'
                }
            );
            console.log(response);
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsLoading(false);
        }
    };

    const redirectToHome = () => {
        setIsSubmitted(false);
        onClose();
        setIsLoading(false);
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] flex flex-col relative overflow-hidden">
                {!isSubmitted ? (
                    <>
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-2xl text-gray-500 hover:text-[#7b45ef] z-50 transition-colors"
                        >
                            <LuX />
                        </button>

                        <div className="bg-gradient-to-r from-[#7b45ef] to-[#e2228c] p-8 text-white flex-shrink-0">
                            <h2 className="text-3xl font-bold mb-2">Professional Consultation Request</h2>
                            <p className="text-white/80 font-light">
                                Connect with our experts and unlock your professional potential
                            </p>
                        </div>

                        <div className="overflow-y-auto flex-grow">
                            <form
                                className="p-8 space-y-6"
                                onSubmit={handleSubmit}
                            >
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Name *
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Your Full Name"
                                            required
                                            name="entry.2146034739"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Industry *
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Your Industry"
                                            required
                                            name="entry.1507897176"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Company/Personal Website
                                        </label>
                                        <input
                                            type="url"
                                            placeholder="https://example.com"
                                            name="entry.1848269972"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Job Title *
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Your Job Title"
                                            required
                                            name="entry.1541972899"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Country *
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Your Country"
                                            required
                                            name="entry.773802672"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            State *
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Your State/Province"
                                            required
                                            name="entry.71589318"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Email *
                                        </label>
                                        <input
                                            type="email"
                                            placeholder="Email"
                                            required
                                            name="entry.2057125456"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            Phone Number *
                                        </label>
                                        <input
                                            type="tel"
                                            placeholder="Phone Number"
                                            required
                                            name="entry.480071125"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 gap-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            LinkedIn Profile *
                                        </label>
                                        <input
                                            // type="url"
                                            type="text"
                                            placeholder="https://www.linkedin.com/in/yourprofile"
                                            // required
                                            name="entry.443205963"
                                            className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Requirements and Expectations *
                                    </label>
                                    <textarea
                                        placeholder="Describe your consultation needs and what you hope to achieve"
                                        required
                                        name="entry.1828522565"
                                        rows="4"
                                        className="w-full p-3 rounded-lg border border-gray-300 focus:border-[#7b45ef] focus:ring-2 focus:ring-[#7b45ef]/30 transition-all"
                                    />
                                </div>

                                <div className="pb-4">
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="w-full flex items-center justify-center py-3 mt-4 
                                        bg-gradient-to-r from-[#7b45ef] to-[#e2228c]
                                        text-white font-semibold rounded-lg 
                                        hover:opacity-90 
                                        transition-all duration-300 
                                        transform hover:scale-[1.02] 
                                        disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {isLoading ? (
                                            <span>Submitting...</span>
                                        ) : (
                                            <>
                                                <LuSend className="mr-2" />
                                                Submit Consultation Request
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                ) : (
                    <div className="p-8 text-center">
                        <div className="mb-6">
                            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Partnership Request Received</h2>
                            <p className="text-gray-600 text-sm">
                            Thank you for your interest in partnering with us! Your request has been successfully submitted. Our team will review your information and reach out to you shortly to discuss potential collaboration opportunities.
                            </p>
                        </div>
                        <button
                            onClick={redirectToHome}
                            className="bg-gradient-to-r from-[#7b45ef] to-[#e2228c] text-white py-2 px-6 rounded-full hover:opacity-90 transition-colors"
                        >
                            Return to Home
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PartnerContact;